import type {
  LabManagedQuiz,
  LabManagedQuizResponses,
  LabPublishedItem,
  LabReviewDecision,
  LabReviewQueueItem,
  LabReviewRelease,
  LabReviewScope,
  LabsReviewApi,
} from './types';

export type LabsPost = <T>(url: string, body?: unknown) => Promise<T>;

export function createLabsReviewApi(post: LabsPost): LabsReviewApi {
  return {
    listQueue: (scope: LabReviewScope) => post<LabReviewQueueItem[]>('/labs/review/queue', { scope }),
    getRelease: (releaseId: string) => post<LabReviewRelease>('/labs/review/release', { releaseId }),
    decide: (releaseId: string, action: LabReviewDecision, note?: string) =>
      post<LabReviewRelease>('/labs/review/decide', { releaseId, action, ...(note ? { note } : {}) }),
    listPublished: () => post<LabPublishedItem[]>('/labs/review/published'),
    takedown: async (projectId: string, note: string) => {
      await post('/labs/review/takedown', { projectId, note });
    },
    downloadSource: (releaseId: string) => post<{ url: string; expiresIn: number }>('/labs/remixes/source', { releaseId }),
    listQuizzes: (projectId: string) => post<LabManagedQuiz[]>('/labs/quizzes/list', { projectId }),
    quizResponses: (quizId: string, page: number, versionId?: string) =>
      post<LabManagedQuizResponses>('/labs/quizzes/responses', { quizId, page, pageSize: 20, ...(versionId ? { versionId } : {}) }),
    exportQuiz: (quizId: string, format: 'csv' | 'json', versionId?: string) =>
      post<{ filename: string; contentType: string; body: string }>('/labs/quizzes/export', { quizId, format, ...(versionId ? { versionId } : {}) }),
  };
}
